import useSnackbar from '@/hooks/ui/use-snackbar.hook'
import GlobalPageLoader from '@/views/components/global-page-loader/index.component'
import SnackbarWrapper from '@/views/components/snackbar/snackbar.component'

import useSidebarUI from '../../hooks/use-sidebar-ui.hook'

const UiFeedbackComponent = () => {
  const { snackbar, closeHandler } = useSnackbar({})

  const { isLoadingFull } = useSidebarUI()

  return (
    <>
      <SnackbarWrapper
        message={snackbar.message}
        open={snackbar.open}
        handleClose={closeHandler}
        variant={snackbar.variant}
        automaticClose
      />
      <GlobalPageLoader open={isLoadingFull} />
    </>
  )
}

export default UiFeedbackComponent
